import { collection, getFirestore } from 'firebase/firestore';

import { app } from '...modules/firebase/web';

const firestore = getFirestore(app);

export default collection(firestore, 'identities');
